<template>
  <div>
    <div class="breadcrumbs mb-2">
      <v-breadcrumbs divider=">" :items="breadcrumbsList">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="{ name: item.path }"
            :disabled="item.disabled"
            exact
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <PageTitle pageHeading="New Ticket" :rightsideButton="false"> </PageTitle>
    <v-container class="create-ticket customize-select">
      <form>
        <v-row class="mr-6">
          <v-col cols="12" class="py-0" align="right">
            <v-btn
              v-if="$can('create','contacts')"
              text
              class="font-weight-bold px-2"
              v-track="'contact-create-button'"
              @click="redirectToContact()"
            >
              <v-icon> mdi-plus </v-icon>
              <span class="pl-2 pr-3"> Add New Contact </span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row class="mr-6">
          <v-col cols="12" class="pb-0 mr-6">
            <ContactField
              page="create"
              :selectedContact="ticket.selectedContact"
              @getValue="ticket.selectedContact = $event"
              :key="reloadComp"
            >
            </ContactField>
          </v-col>
        </v-row>

        <v-row class="mr-6">
          <v-col cols="12" class="pb-0 mr-6">
            <v-text-field
              v-model="ticket.subject"
              :error-messages="subjectErrors"
              label="Subject"
              class="required text-field"
              outlined
              required
              @input="$v.ticket.subject.$touch()"
              @blur="$v.ticket.subject.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>
        <!-- <v-row class="">
          <v-col cols="12" class="pb-0">
            <ParentTicket
              page="create"
              :parentTicket="ticket.parentTicket"
              @getValue="ticket.parentTicket = $event"
              :key="reloadParentTicket"
            >
            </ParentTicket>
          </v-col>
        </v-row> -->
        <!-- <v-row class="mr-6">
          <v-col cols="12" class="pb-0 mr-6">
            <v-autocomplete
              v-model="ticket.selectedGroup"
              :items="associatedField.groups.list"
              item-text="name"
              item-value="id"
              label="Group"
              autocomplete="off"
              outlined
              attach
            >
              <template v-slot:append-item>
                <div v-intersect="loadMoreGroups" class="pa-4 teal--text"></div>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row> -->
        <v-row class="mr-6">
          <v-col cols="12" class="pb-0 mr-6">
            <v-autocomplete
              v-model="ticket.ticketType"
              :items="associatedField.types.list"
              item-text="name"
              item-value="id"
              label="Type"
              autocomplete="off"
              outlined
              attach
            >
              <template v-slot:append-item>
                <div
                  v-intersect="loadMoreTicketTypes"
                  class="pa-4 teal--text"
                ></div>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mr-6">
          <v-col cols="12" class="pb-0 mr-6">
            <v-select
              v-model="ticket.channel"
              :items="filteredChannelList"
              :item-text="(item) => item.name.replace('_', ' ')"
              item-value="name"
              :error-messages="channelErrors"
              label="Channel"
              class="required"
              outlined
              attach
              required
              @change="$v.ticket.channel.$touch()"
              @blur="$v.ticket.channel.$touch()"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mr-6">
          <v-col cols="12" class="pb-0 mr-6">
            <v-select
              v-model="ticket.status"
              :items="associatedField.statusList"
              :error-messages="statusErrors"
              label="Status"
              :item-text="(item) => item.name.replace('_', ' ')"
              item-value="name"
              class="required"
              outlined
              attach
              required
              @change="$v.ticket.status.$touch()"
              @blur="$v.ticket.status.$touch()"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mr-6">
          <v-col cols="12" class="pb-0 mr-6">
            <v-select
              v-model="ticket.priority"
              :items="associatedField.priorities"
              :error-messages="priorityErrors"
              label="Priority"
              class="required"
              item-text="name"
              item-value="name"
              outlined
              required
              attach
              @change="$v.ticket.priority.$touch()"
              @blur="$v.ticket.priority.$touch()"
            ></v-select>
          </v-col>
        </v-row>
        <v-row class="mr-6">
          <v-col cols="12" class="pb-0 mr-6">
            <v-autocomplete
              v-model="ticket.selectedAgent"
              :items="associatedField.agentList"
              item-text="agent_name"
              item-value="id"
              label="Agent"
              class=""
              outlined
              attach
              required
              :no-filter="associatedField.agentList && associatedField.agentList.length > 5 ? true : false"
              :search-input.sync="searchAgentKeyword"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="mr-6">
          <v-col cols="12" class="pb-0">
            <p class="body-1 mb-1">Description *</p>
            <v-card outlined height="230" class="overflow-auto">
              <CKEditor
                @update="ticket.description = $event"
                :body="ticket.description"
                :key="loadCKeditor"
              >
              </CKEditor>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" v-if="ticket.attachmentFiles.length">
            <h6 class="text-subtitle-1">
              <span class="secondary--font">
                Attachments ({{ ticket.attachmentFiles.length }})
              </span>
            </h6>
            <template v-for="(file, index) in ticket.attachmentFiles">
              <v-chip
                color="#CBDAE8"
                :key="index"
                class="ml-0 ma-2 mr-3"
                close
                @click:close="removeAttchment(file.name)"
              >
                {{ file.name }}
              </v-chip>
            </template>
          </v-col>
          <v-col cols="12" class="mb-5">
            <FileUploadModal
              @saveAttachment="saveAttachment"
              page="create-ticket"
            >
            </FileUploadModal>
          </v-col>
        </v-row>

        <v-divider class="my-5"></v-divider>
        <v-btn
          @click="cancelDialog = true"
          outlined
          id="cancel-action"
          v-track="'cancel-create-ticket-btn'"
          class="font-weight-bold"
        >
          Cancel
        </v-btn>
        <v-btn
          id="create-new-ticket"
          v-track="'ticket-create-btn'"
          class="mr-4 ml-2 font-weight-bold white--text"
          @click="createNewTicket"
          :dark="!this.$v.$invalid && ticket.description !== null"
          :disabled="this.$v.$invalid"
        >
          Create
        </v-btn>
      </form>
    </v-container>
    <v-dialog v-model="cancelDialog" max-width="500">
      <v-card class="pa-2 py-3">
        <v-card-title class="text-h6 font-weight-600">
          <span class="secondary--font"> Cancel Ticket </span>
        </v-card-title>
        <v-card-text class="body-2">
          Are you sure you want to cancel the ticket ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelDialog = false" class="font-weight-bold" v-track="'cancel-ticket-create'">
            Cancel
          </v-btn>
          <v-btn dark @click="confirmCancel()" class="font-weight-bold" v-track="'confirm-ticket-create'">
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="createLoader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import PageTitle from "@/components/shared/PageTitle";
import ContactField from "@/components/tickets/ContactsField";
import FileUploadModal from "@/components/file_uploader/UploadFile";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { $tickets } from "@/services/Index";
import { ticketMixin } from "@/mixins/ticket";
//import ParentTicket from "@/components/tickets/ParentTicket";
import CKEditor from "@/components/ckeditor/Editor";

export default {
  name: "NewTicket",
  mixins: [validationMixin, ticketMixin],
  validations: {
    ticket: {
      selectedContact: { required },
      subject: { required },
      channel: { required },
      status: { required },
      priority: { required },
      description: { required },
    },
  },
  components: {
    PageTitle,
    FileUploadModal,
    // ParentTicket,
    ContactField,
    CKEditor,
  },
  data: () => ({
    breadcrumbsList: [
      {
        text: "All Tickets",
        disabled: false,
        path: "tickets",
      },
      {
        text: "New Ticket",
        disabled: false,
        path: "",
      },
    ],
    loadCKeditor: false,
    ticket: {
      selectedContact: null,
      subject: null,
      selectedGroup: null,
      ticketType: null,
      channel: "inbound_call",
      status: "new",
      priority: "low",
      selectedAgent: null,
      parentTicket: "",
      description: null,
      attachmentFiles: [],
      reloadCustomCmp: false,
    },
    cancelDialog: false,
    createLoader: false,
    reloadParentTicket: false,
    reloadComp: false,
  }),

  computed: {
    associatedField() {
      return this.$store.getters["tickets/associatedField"];
    },

    subjectErrors() {
      const errors = [];
      if (!this.$v.ticket.subject.$dirty) return errors;
      !this.$v.ticket.subject.required && errors.push("Subject is required.");
      return errors;
    },

    channelErrors() {
      const errors = [];
      if (!this.$v.ticket.channel.$dirty) return errors;
      !this.$v.ticket.channel.required && errors.push("Channel is required");
      return errors;
    },
    statusErrors() {
      const errors = [];
      if (!this.$v.ticket.status.$dirty) return errors;
      !this.$v.ticket.status.required && errors.push("Status is required");
      return errors;
    },
    priorityErrors() {
      const errors = [];
      if (!this.$v.ticket.priority.$dirty) return errors;
      !this.$v.ticket.priority.required && errors.push("Priority is required");
      return errors;
    },

    filteredChannelList() {
      let filteredList = this.associatedField.channelList.filter((channel) => {
        return channel.name !== "webstore" && channel.name !== "email";
      });
      return filteredList;
    },
  },

  watch: {
    "ticket.description": {
      handler: function (val) {
        this.ticket.description = this.$options.filters.upperCaseFirst(val);
      },
    },
  },
  mounted() {
    if (this.associatedField.statusList.length == 0) {
      this.getStatusList();
      this.getPriorityList();
      this.getTicketTypes();
      this.getGroupList();
      this.getChannelList();
    }
    /** while creating new followup ticket */
    if (this.$route.query.Id) {
      this.getSingleTicket(this.$route.query.Id);
    }

    if (this.$route.query.addcontact) {
      this.checkDataInSession();
    }
  },
  methods: {
    clear() {
      this.$v.$reset();
      this.cancelNewTicket();
    },

    checkDataInSession() {
      if (sessionStorage.getItem("new-contact")) {
        let contact = JSON.parse(sessionStorage.getItem("new-contact"));
        let ticketData = JSON.parse(sessionStorage.getItem("ticket-data"));
        this.ticket = ticketData;
        this.ticket.selectedContact = contact.id;
        this.reloadComp = !this.reloadComp;
        this.reloadParentTicket = !this.reloadParentTicket;
        this.ticket.attachmentFiles.length = 0;
      }
    },
    redirectToContact() {
      sessionStorage.setItem("ticket-data", JSON.stringify(this.ticket));
      this.$router.push({ name: "create-contact", query: { ticket: true } });
    },

    async createNewTicket() {
      this.$v.$touch();
      let payload = null;
      var data = {
        ticket: {
          contact_id: this.ticket.selectedContact,
          subject: this.ticket.subject,
          ...(this.ticket.ticketType && { ticket_type_id: this.ticket.ticketType }),
          channel: this.ticket.channel,
          status: this.ticket.status,
          priority: this.ticket.priority,
          ...(this.ticket.selectedAgent && { agent_id: this.ticket.selectedAgent }),
          description: this.ticket.description,
        },
      };
      payload = data;
      let config = {};
      const formdata = new FormData();
      if (this.ticket.attachmentFiles.length) {
        config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };
        let ticketdata = data.ticket;
        for (var key in ticketdata) {
          formdata.append(key, ticketdata[key]);
        }
        this.ticket.attachmentFiles.forEach((file) => {
          formdata.append("attachments[]", file);
        });
        payload = formdata;
      }

      if (!this.$v.$invalid) {
        this.createLoader = true;
        try {
          const response = await $tickets.create(payload, config);
          if (response.data) {
            this.$router.push({ name: "tickets" });
            this.$store.dispatch("ui/snackbar", [
              {
                title: "New Ticket",
                message: `New ticket #${response.data.id} created`,
                type: "success",
              },
            ]);
            this.createLoader = false;

            if (sessionStorage.getItem("new-contact") !== null)
              sessionStorage.removeItem("new-contact");
            if (sessionStorage.getItem("ticket-data") !== null)
              sessionStorage.removeItem("ticket-data");
          }
        } catch (error) {
          this.createLoader = false;
          if (error.response !== undefined) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
          }
        }
      }
    },

    confirmCancel() {
      this.$router.push({ name: "tickets" });
    },

    generateFormData(data) {
      const formdata = new FormData();
      let ticket = data.ticket;
      for (var key in ticket) {
        formdata.append(key, ticket[key]);
      }
      return formdata;
    },

    cancelNewTicket() {
      this.$emit("cancel", true);
    },

    saveAttachment(data) {
      if (this.ticket.attachmentFiles.length !== 0) {
        data.forEach((item) => {
          if (!this.checkDuplicateFile(this.ticket.attachmentFiles, item))
            this.ticket.attachmentFiles.push(item);
        });
      } else {
        this.ticket.attachmentFiles = data;
      }
    },

    removeAttchment(fileName) {
      this.ticket.attachmentFiles = this.ticket.attachmentFiles.filter(
        (file) => {
          return fileName !== file.name;
        }
      );
    },

    checkDuplicateFile(existingFile, file) {
      let duplicate = false;
      existingFile.forEach((existFile) => {
        if (existFile.name === file.name) duplicate = true;
      });
      return duplicate;
    },

    /* eslint-disable */
    /** get single ticket data */
    async getSingleTicket(ticketId) {
      try {
        const response = await $tickets.fetchSingle(ticketId, {});
        if (response.data) {
          this.updateFields(response.data);
        }
      } catch (error) {}
    },
    updateFields(data) {
      this.ticket.selectedContact = data.contact_id;
      this.ticket.subject = `Ref: ${data.subject}`;
      this.ticket.parentTicket = data.id;
      this.ticket.description = data.description;
      this.reloadParentTicket = !this.reloadParentTicket;
      this.reloadComp = !this.reloadComp;
    },
  },
};
</script>

<style lang="scss"></style>
